module.exports = __webpack_public_path__ + "img/sceneIcon4-3.6f3f72a6.png";